module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="table-header">\n	<div class="table-item rank-item" data-order="rank">Rank</div>\n	<div class="table-item name" data-order="team_name">Team name</div>\n	<div class="table-item avatar"></div>\n	<div class="table-item">Streak length</div>\n	<div class="table-item">Margin</div>\n</div>';
}
return __p;
};
